/**
 * This is the top-level React container for the Student Helper feature,
 * allowing the teacher to turn on Student Helper for an assignment.
 */

import { useState } from "react"

import { StudentHelperTeacherController } from "./StudentHelperTeacher.controller"
import { StudentHelperInfoModal } from "./components/StudentHelperInfoModal/StudentHelperInfoModal"
import { StudentHelperMenu } from "./components/StudentHelperMenu/StudentHelperMenu"

interface StudentHelperTeacherProps {
  controller: StudentHelperTeacherController
}

export function StudentHelperTeacher({
  controller,
}: StudentHelperTeacherProps) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  function openModal() {
    setIsModalOpen(true)
  }

  function closeModal() {
    setIsModalOpen(false)
  }

  return (
    <>
      <StudentHelperMenu controller={controller} onShowInfo={openModal} />

      <StudentHelperInfoModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  )
}
